export type ConfigSection = {
  key: string;
  titleKey: string;
  titleFallback?: string;
  hasAdd?: boolean;
  hasToggle?: boolean;
  defaultEnabled?: boolean;
  comingSoon?: boolean;
  badgeLabelKey?: string;
  badgeLabelFallback?: string;
  contentKey?: string;
  contentFallback?: string;
};

export const CONFIG_SECTIONS: ConfigSection[] = [
  {
    key: 'llm',
    titleKey: 'LLM',
    titleFallback: 'LLM',
    contentKey: 'AGENT_CONFIG_SECTION_LLM_CONTENT',
    contentFallback: 'Choose the language model and tune how this agent should respond.',
  },
  {
    // Hidden while souls are off for the tenant or the soul API is not deployed.
    key: 'soul',
    titleKey: 'AGENT_SOUL_TITLE',
    titleFallback: 'Soul',
  },
  {
    key: 'knowledge-base',
    titleKey: 'KNOWLEDGE_BASE',
    titleFallback: 'Knowledge Base',
    hasAdd: true,
    hasToggle: true,
    defaultEnabled: true,
    contentKey: 'AGENT_CONFIG_SECTION_KNOWLEDGE_BASE_CONTENT',
    contentFallback: 'Connect folders, documents, or indexed sources for grounded answers.',
  },
  {
    key: 'tools',
    titleKey: 'TOOLS',
    titleFallback: 'Tools',
    hasAdd: true,
    hasToggle: true,
    defaultEnabled: false,
    contentKey: 'AGENT_CONFIG_SECTION_TOOLS_CONTENT',
    contentFallback: 'Attach external tools and actions the agent can use when needed.',
  },
  {
    key: 'skills',
    titleKey: 'SKILLS',
    titleFallback: 'Skills',
    hasAdd: true,
    hasToggle: true,
    defaultEnabled: false,
    contentKey: 'AGENT_CONFIG_SECTION_SKILLS_CONTENT',
    contentFallback: 'Attach standing skills the agent can use across conversations.',
  },
  {
    key: 'subagents',
    titleKey: 'SUBAGENTS',
    titleFallback: 'Subagents',
    hasAdd: true,
    hasToggle: true,
    defaultEnabled: false,
    contentKey: 'AGENT_CONFIG_SECTION_SUBAGENTS_CONTENT',
    contentFallback: 'Attach other agents this agent can delegate work to.',
  },
  // {
  //   key: 'memory',
  //   titleKey: 'MEMORY',
  //   titleFallback: 'Memory',
  //   contentKey: 'AGENT_CONFIG_SECTION_MEMORY_CONTENT',
  //   contentFallback: 'Control what the agent should remember across conversations.',
  // },
  {
    key: 'welcome-guide',
    titleKey: 'WELCOME_GUIDE',
    titleFallback: 'Welcome Guide',
    contentKey: 'AGENT_CONFIG_SECTION_WELCOME_GUIDE_CONTENT',
    contentFallback: 'Set the greeting and the first impression shown in preview.',
  },
  // {
  //   key: 'human-handoff',
  //   titleKey: 'HUMAN_HANDOFF',
  //   titleFallback: 'Human Handoff',
  //   hasToggle: true,
  //   defaultEnabled: false,
  //   comingSoon: true,
  //   badgeLabelKey: 'HUMAN_HANDOFF_BADGE_COMING_SOON',
  //   badgeLabelFallback: 'Coming Soon',
  //   contentKey: 'HUMAN_HANDOFF_BADGE_COMING_SOON',
  //   contentFallback: 'Escalate conversations to a human when the situation requires it.',
  // },
  {
    key: 'guardrails',
    titleKey: 'GUARDRAILS',
    titleFallback: 'Guardrails',
    hasAdd: false,
    hasToggle: true,
    defaultEnabled: false,
    contentKey: 'AGENT_CONFIG_SECTION_GUARDRAILS_CONTENT',
    contentFallback: 'Define the safety boundaries and behavior rules for the agent.',
  },
];

export const isConfigSectionComingSoon = (key: string): boolean =>
  CONFIG_SECTIONS.find((section) => section.key === key)?.comingSoon ?? false;
